const playback = {
  path: 'playback',
  component: resolve => require(['../../../../pages/user/videoplay/playback'], resolve)
}

export default playback



// WEBPACK FOOTER //
// ./src/router/user/videoplay/playback/index.js